import queryString from 'query-string'
import apiClient from './api-client'

function getPracticeFormOptions(page = 1, perPage = 10, practiceId) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'practice_form_options/',
      query: {
        practice_id: practiceId,
        page,
        per_page: perPage,
      },
    }),
  )
}

function addPracticeFormOption(data) {
  return apiClient.post('/practice_form_options', data)
}

function deletePracticeFormOption(id) {
  return apiClient.destroy(`/practice_form_options/${id}`)
}

function updatePracticeFormOption(id, data) {
  return apiClient.patch(`/practice_form_options/${id}`, data)
}

export default {
  getPracticeFormOptions,
  addPracticeFormOption,
  deletePracticeFormOption,
  updatePracticeFormOption,
}
